import { render } from 'react-dom'
import { initContext } from '../../helpers/commonDepend.jsx'
import RootHY from '../roots/hy-day.jsx'
import RootDF from '../roots/df-day.jsx'
import configureStore from '../../store/configureStore'

initContext();
const store = configureStore();

$.setCookie('vers',window.vers);

var Root;
switch(window.vers){
    case 'hy':  // 恒耀
        Root = RootHY;
        break;
    case 'df':  // 达福
        Root = RootDF;
        break;
    default:
        Root = RootHY;
}

render(<Root store={store} />, document.getElementById('root'));

// 热更新
if (module.hot) {
  module.hot.accept();
}
